<ion-app>
  <pkp-menu></pkp-menu>
  <div class="ion-page" id="main-content">
    <pkp-header></pkp-header>

    <ion-content>
      <ion-router-outlet></ion-router-outlet>
    </ion-content>
    <pkp-log-panel></pkp-log-panel>
  </div>
</ion-app>
